import React, { useEffect, useState } from "react";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Login from "../pages/auth/Login";
import { routes } from "./Sidebar";
import Sidebar from "../comman/Sidebar";
import ForgotPassword from "../pages/auth/BeforeForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import GoToLoginPage from "../pages/auth/GoToLoginPage";
import LoginSuccess from "../pages/auth/passwordResetSuccess";
import Header from "../comman/Header";
import Error from "../components/not-found/Error";
import { auth } from "./route";
import SelectedConsultantForm from "../pages/consultantManagement.jsx/SelectedConsultantForm";
import { useDispatch, useSelector } from "react-redux";
import { setRightsInfo, setRole } from "../utils/store/slices/rightsSlice";
import { normalizeRightsBooleans } from "../utils/normalizeRights";
import useResponsive from "../hooks/useResponsive";
import useNavigationTracker from "../hooks/useNavigationTracker";
const { FORGET_PASSWORD_ROUTE, RESET_PASSWORD_ROUTE } = auth;

/** Marketing-only sub-admins must not stay on /dashboard (bookmark / old session). */
function SubAdminMainDashboardRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const { rightsInfo, role } = useSelector((state) => state?.vedicRights);

  useEffect(() => {
    if (String(role || "").trim().toLowerCase() !== "sub-admin") return;
    if (location.pathname !== "/dashboard") return;
    const hasMain = rightsInfo?.["dashboard-management"] === true;
    const hasMkt = rightsInfo?.["marketing-dashboard-management"] === true;
    if (!hasMain && hasMkt) {
      navigate("/dashboard-marketing", { replace: true });
    }
  }, [location.pathname, role, rightsInfo, navigate]);

  return null;
}

const Routing = () => {
  const dispatch = useDispatch();
  const { rightsInfo, role } = useSelector((state) => state?.vedicRights);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isMobile } = useResponsive();

  const handleMenuToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  // Close sidebar when switching from mobile to desktop
  useEffect(() => {
    if (!isMobile && isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  }, [isMobile, isSidebarOpen]);

  const SidebarLayout = () => {
    useNavigationTracker();
    return (
      <>
        <Header onMenuToggle={handleMenuToggle} isSidebarOpen={isSidebarOpen} />
        <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
        <SubAdminMainDashboardRedirect />
        <Outlet />
      </>
    );
  };

  const ProtectedRoute = ({ children }) => {
    if (!localStorage.getItem("vedic_token")) {
      return <Navigate to="/" replace />;
    } else {
      return children;
    }
  };

  useEffect(() => {
    let parsed = {};
    try {
      parsed = JSON.parse(localStorage.getItem("vedic_rights") || "{}");
    } catch {
      parsed = {};
    }
    dispatch(setRightsInfo({ rightsInfo: normalizeRightsBooleans(parsed) }));
    dispatch(setRole({ role: localStorage.getItem("vedic_role") }));
  }, [dispatch]);

  return (
    <Routes>
      {/* ------------------------------------- before Login Routes----------------------------------------------------- */}
      <Route path="/" element={<Login />} />
      <Route path={FORGET_PASSWORD_ROUTE} element={<ForgotPassword />} />
      {/* <Route path="/go-to-login-page" element={<GoToLoginPage />} /> */}
      <Route
        path={`${RESET_PASSWORD_ROUTE}/:token`}
        element={<ResetPassword />}
      />
      <Route path="/password-reset-success" element={<LoginSuccess />} />
      <Route path="/selected-consultant-form/:token" element={<SelectedConsultantForm />} />

      {/* ------------------------------------- After Login Routes----------------------------------------------------- */}
      <Route element={<SidebarLayout />}>
        {routes(rightsInfo, role).map(({ id, path, element }) => (
          <Route
            key={`${String(path)}-${String(id)}`}
            path={path}
            element={<ProtectedRoute>{element}</ProtectedRoute>}
          />
        ))}
      </Route>
      <Route path="*" element={<ProtectedRoute>{<Error />}</ProtectedRoute>} />
    </Routes>
  );
};

export default Routing;
